<template>
<div>

    <div v-if="result.length>0">

        <ul >
            <li v-for="colmena in result" :key="colmena.id" v-bind:class="'card border-bottom-color-'+colmena.vigor" v-bind:id="'colmenar'+colmena.id" >

                <div class="info-item">

                    <div class="info-item-list-left" >
                        <router-link v-bind:to="'/colmena/' + colmena.id" v-bind:id="'c' + colmena.id" >

                            <p class="title-box">{{ colmena.number }}</p>
                            <div v-if="colmena.position>0" style="position: absolute; right: 14%;top: 12px; padding: 2px 5px 2px 5px; border:1px solid #999">{{colmena.position}}</div>
                            <div v-else style="position: absolute; right: 14%;top: 12px; padding: 2px 5px 2px 5px; border:1px solid red" class="text-red">Sin posición</div>

                            <p v-if="colmena.core==='1'" ><v-icon color="orange">mdi-archive</v-icon> <b> NÚCLEO</b></p>

                            <span class="iconify" data-icon="mdi:beehive-off-outline" data-inline="false"></span>

                            <p> Última visita: <span v-if="colmena.lastvisit">{{ colmena.lastvisit }} <span v-if="colmena.return>0" class="text-red"> - VOLVER PRONTO</span></span> <span v-else>Sin visitas</span></p>

                            <p v-if="colmena.frame_number_final"><b>Cuadros de cría que se quedaron: </b>
                                <span >{{ colmena.frame_number_final }}</span>
                            </p>

                            
                            <p v-if="colmena.frame_with_bee_number"><b>Cuadros de cría al iniciar la visita: </b>
                                <span >{{ colmena.frame_with_bee_number }}, {{ colmena.frame_with_bee_size }}</span>
                            </p>

                            

                            <p><b>Alzas:</b>&nbsp;
                            <span v-if="colmena.alza === '1'">{{colmena.alza_value}}</span>
                            <span v-else>NO</span>
                            </p>


                            <p v-if="colmena.tasks==='0'"> <v-icon>mdi-bell-alert-outline</v-icon> Tareas: 0</p>
                            <p v-else class="text-red"><v-icon color="red">mdi-bell-alert-outline</v-icon> <b>Tareas:</b> {{ colmena.tasks }}</p>

                            <p>
                               <span v-if="colmena.namequeen!=null" >
                                       <v-icon color="">mdi-crown-outline</v-icon>
                                        <span v-bind:class="'badge badge-'+colmena.color">{{ colmena.year }}</span>
                                        &nbsp;<b>{{colmena.namequeen}}</b>&nbsp;
                               <span v-if="colmena.color==='sin marcar'" class="text-red" style="font-size:0.70rem;">Colmena sin marcar</span>

                               </span>
                                <span v-else class="text-red">
                                       <v-icon color="red">mdi-crown-outline</v-icon>
                                       Sin reina
                                </span>
                            </p>
                            <!--p><v-icon>mdi-bug-outline</v-icon> Tests de varroa: {{ colmena.testvarroa }}</p-->




                            <p  v-if="colmena.cheerup">
                                <v-icon>mdi-alert-circle-outline</v-icon>

                                <b  style="margin-left:2px;">
                                           <span class="let badge " v-bind:class="{'badge-rojo': colmena.cheerup === 'alta',
                                                   'badge-amarillo': colmena.cheerup === 'media',
                                            'badge-verde': colmena.cheerup !== 'alta'
                                            }"

                                                 style="text-align:center;">{{ colmena.cheerup }}</span>
                                    &nbsp;<span style="padding-right:5px;">Agresividad</span>
                                </b>
                            </p>

                            <p v-if="colmena.vigor"><vigor v-bind:vigor="colmena.vigor" ></vigor></p>

                        </router-link>


                    </div>

                    <div class="info-item-list-right">
                        <a v-bind:href="'#/colmena/' + colmena.id">
                            <v-icon color="grey">mdi-chevron-right</v-icon>
                        </a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div v-else class="card">

        <div style="padding:20px; text-align:center">

            <p v-if="core==='0'">No hay colmenas en este colmenar.</p>
            <p v-else>No hay núcleos en este colmenar.</p>

        </div>
        <router-link v-bind:to="'../colmena-nueva/'+idcolmenar" class="btn btn-yellow" >
            <p style="color:#FFF" v-if="core==='0'">Añadir colmena</p>
            <p style="color:#FFF" v-else>Añadir núcleo</p>
        </router-link>

    </div>

</div>
</template>

<script>

import vigor from "@/components/hive_state/vigor"

export default {
    name: 'listar-colmenas',
    props: ['result','core', 'idcolmenar'],
    components: {vigor}
};
</script>